import { createSelector } from '@reduxjs/toolkit';

import { CommonRootState } from '../root.reducer';

const selectSelf = (state: CommonRootState) => state.userInfoLoad;

export const hasSucceededLoadingUserInfo = createSelector(selectSelf, state => state.userInfoLoadSuccess === true);
export const isLoadingUserInfo = createSelector(selectSelf, state => state.userInfoLoadSuccess === undefined);
export const isUserInfoUnavailable = createSelector(
  selectSelf,
  state => state.userInfoLoadSuccess === false && !state.hasEverLoaded
);
